module.exports = __webpack_public_path__ + "bj.svg?f541db1f616ff30a922b1be964f0ce78";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/bj.svg
// module id = 758
// module chunks = 27